import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import CommentInput from './CommentInput';
import ICON_CHECK_LIGHT from '../../../public/static/v4/comment/icon-check-light.svg';
import ICON_CHECK from '../../../public/static/v4/comment/icon-check.svg';
import ICON_UNCHECK_LIGHT from '../../../public/static/v4/comment/icon-uncheck-light.svg';
import ICON_UNCHECK from '../../../public/static/v4/comment/icon-uncheck.svg';
import CheckBoxV4 from '../../common/component/CheckBoxV4';
import useTheme from '../../common/hook/useTheme';
import {ICommentInputVariant} from '../type';
interface IProps {
  variant?: ICommentInputVariant;
  className?: string;
  useSpoiler?: boolean;
  onClickPost: (content: string, isSpoiler: boolean) => void;
}

export default function ParentInput({
  variant,
  useSpoiler = true,
  className,
  onClickPost,
}: IProps) {
  const {t} = useTranslation();
  const [isSpoiler, setIsSpoiler] = useState(false);
  const {isLightMode} = useTheme();

  return (
    <div className={cn('pb-10 px-11 relative', className)}>
      <CommentInput
        variant={variant}
        isReply={false}
        onClickPost={content => {
          onClickPost(content, isSpoiler);
          setIsSpoiler(false);
        }}
        spoilerElement={
          useSpoiler ? (
            <div className="flex">
              <CheckBoxV4
                id="parentInput"
                className="bg-grey-01 py-4 pl-5 pr-8 rounded-5"
                imgChecked={isLightMode ? ICON_CHECK_LIGHT : ICON_CHECK}
                imgUnchecked={isLightMode ? ICON_UNCHECK_LIGHT : ICON_UNCHECK}
                imgWidth={14}
                label={t('comment_write_spoiler_button')}
                labelClassName={cn(
                  's13-semibold-grey06',
                  isSpoiler && '!text-red'
                )}
                labelDistance={4}
                checked={isSpoiler}
                onChange={() => setIsSpoiler(isChecked => !isChecked)}
              />
            </div>
          ) : undefined
        }
      />
    </div>
  );
}
